import * as React from 'react';
import b_ from 'b_';
import SingleTooltip from 'components/SingleTooltip';
import TooltipContent from './Tooltip';
import { OrderStatusFragment } from './__generated__/OrderStatusFragment';
import { Content } from './Content';

import './index.scss';

type Order = OrderStatusFragment;

interface Props {
  order: Order;
}

const b = b_.with('order-card-status');

export const Status: React.FC<Props> = ({ order }) => (
  <div className={b()}>
    <SingleTooltip placement="top" overlay={<TooltipContent order={order} />}>
      <div data-testid="status">
        <Content order={order} />
      </div>
    </SingleTooltip>
  </div>
);
